export const requestConfig = {
  url: '/api',
  // url: 'http://127.0.0.1:8081',
  // url: '/proxy',
  timeout: 30000
}
export const u9requestConfig = {
  // url: 'http://10.1.0.237:9001',
  url: '/u9',
  // productionUrl:'http://10.1.5.251:9001',
  timeout: 30000
}


// WEBPACK FOOTER //
// ./src/api/index.js